import React, { cloneElement, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Card, CardHeader, CardText, FontIcon, Tabs, Tab, RadioButton, RadioButtonGroup } from 'material-ui';
import TypeIcon from 'material-ui/svg-icons/maps/local-offer';
import { mainCategories } from './categoryOptions';
import R from 'ramda';

const isNilOrEmpty = R.either(R.isEmpty, R.isNil);

const Category = props => {
  const {
    onCardExpand,
    expanded,
    mainCategorySelect,
    subCategorySelect,
    selectedSubCategory,
    savingPost,
    selectedMainCategory,
  } = props;

  const getHashtag = (mainCategoryVal) => R.call(R.compose(
    R.prop(0),
    R.pluck('hashtag'),
    R.filter(obj => obj.val === mainCategoryVal),
    R.chain(obj => obj.subCategories)
  ), mainCategories);

  const subCategorySelection = R.call(R.cond([
    [R.equals('Industry Insights'), R.always(R.path([1, 'subCategories'], mainCategories))],
    [R.equals('Training & Famils'), R.always(R.path([2, 'subCategories'], mainCategories))],
    [R.equals('Destination Updates'), R.always(R.path([3, 'subCategories'], mainCategories))],
    [R.T, R.always(R.path([0, 'subCategories'], mainCategories))],
  ]), selectedMainCategory);

  return (
    <div>
      <Tabs
        tabItemContainerStyle={{ backgroundColor: 'white', borderBottom: '1px solid #e0e0e0', justifyContent: 'space-between', padding: '0 10px' }}
        onChange={mainCategorySelect}
        inkBarStyle={{ display: 'none' }}
      >
        {
          mainCategories.map((obj, i) => {
            return (
              <Tab
                key={i}
                label={obj.mainCategory}
                value={obj.mainCategory}
                style={Object.assign({}, { color: 'rgba(0, 0, 0, 0.54)', fontSize: '12px', width: 'auto' }, obj.mainCategory === selectedMainCategory ? { fontWeight: 600 } : {})}
              />
            );
          })
        }
      </Tabs>
      <Card
        expanded={expanded}
        onExpandChange={onCardExpand}
        style={{ boxShadow: 'none', borderBottom: '1px solid #e0e0e0', marginBottom: '4px' }}
      >
        <CardHeader actAsExpander showExpandableButton textStyle={{ display: 'none' }}>
          <div>
            <FontIcon>
              <TypeIcon color={'rgba(0, 0, 0, 0.54)'} style={{ verticalAlign: 'bottom' }} />
              <span style={{ fontSize: '16px', color: 'rgba(0, 0, 0, 0.54)', marginLeft: '15px' }}>
                Choose Category
                {!isNilOrEmpty(selectedSubCategory) && !expanded &&
                  <span> - <span style={{ color: '#00bcd4' }}>{R.call(R.compose(
                    R.view(R.lensProp('text')),
                    R.prop(0),
                    R.filter(item => item.val === selectedSubCategory),
                    R.flatten,
                    R.pluck('subCategories')
                  ), mainCategories)} selected</span></span>}
              </span>
            </FontIcon>
          </div>
        </CardHeader>
        <CardText expandable style={{ padding: 0 }}>
          <div style={{ paddingLeft: '55px' }}>
            <RadioButtonGroup name="subCategory" onChange={(_, value) => subCategorySelect(value, getHashtag(value))} valueSelected={selectedSubCategory}>
              {
                subCategorySelection.map((subCategory, i) => {
                  return (
                    <RadioButton
                      key={i}
                      label={subCategory.text}
                      value={subCategory.val}
                      disabled={savingPost}
                    />
                  );
                })
              }
            </RadioButtonGroup>
          </div>
        </CardText>
      </Card>
    </div>
  );
};

Category.propTypes = {
  onCardExpand: PropTypes.func,
  expanded: PropTypes.bool,
  mainCategorySelect: PropTypes.func,
  subCategorySelect: PropTypes.func,
  selectedSubCategory: PropTypes.string,
  savingPost: PropTypes.bool,
  selectedMainCategory: PropTypes.string,
};

const mapStateToProps = ({ newsfeed }) => ({
  selectedSubCategory: newsfeed.get('selectedSubCategory'),
  savingPost: newsfeed.get('savingPost'),
  selectedMainCategory: newsfeed.get('selectedMainCategory'),
});

export default connect(mapStateToProps)(Category);



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/mainFeed/newPost/category.jsx